var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaentertaintment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M10.125.375h-5.25a.563.563 0 0 0-.563.563v3.187H1.876a.563.563 0 0 0-.563.563v3.75a3.188 3.188 0 0 0 6.375 0v-.573a3.189 3.189 0 0 0 3-3.178V.938a.563.563 0 0 0-.562-.562ZM6.937 8.438a2.438 2.438 0 0 1-4.875 0V4.874h4.876v3.563Zm3-3.75a2.44 2.44 0 0 1-2.25 2.427V4.687a.563.563 0 0 0-.562-.562H5.062v-3h4.875v3.563Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M3.188 6.938a.187.187 0 1 1 .374 0 .375.375 0 0 0 .75 0 .937.937 0 1 0-1.875 0 .375.375 0 0 0 .75 0Zm1.875.375a.375.375 0 0 0 .375-.375.187.187 0 1 1 .375 0 .375.375 0 0 0 .75 0 .937.937 0 1 0-1.875 0 .375.375 0 0 0 .375.375Zm3.562-3.75a.939.939 0 0 0 .938-.938.375.375 0 1 0-.75 0 .187.187 0 1 1-.376 0 .375.375 0 1 0-.75 0 .939.939 0 0 0 .938.938Zm-2.25 0a.939.939 0 0 0 .938-.938.375.375 0 1 0-.75 0 .187.187 0 1 1-.375 0 .375.375 0 1 0-.75 0 .939.939 0 0 0 .937.938Zm-.562 4.5H3.188a.375.375 0 0 0-.376.374 1.687 1.687 0 0 0 3.376 0 .375.375 0 0 0-.375-.374ZM4.5 9.374a.939.939 0 0 1-.86-.563h1.72a.939.939 0 0 1-.86.563Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaentertaintment);
export default __webpack_public_path__ + "static/media/vaentertaintment.596281530aa6195b2a2600ae5223a4f1.svg";
export { ForwardRef as ReactComponent };